// SEO Structured Data for Digital Scanning Group

const getSiteUrl = () => 'https://www.digitalscanninggroup.com';

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Digital Scanning Group",
  "alternateName": "DSG",
  "description": "Professional Matterport 3D surveys, point cloud scanning, Revit BIM modelling, drone surveys and timelapse cameras across Europe and worldwide. Trusted by NHS Trusts, Tier 1 contractors and FTSE 100 companies.",
  "url": "https://www.digitalscanninggroup.com",
  "logo": "https://www.digitalscanninggroup.com/logo.png",
  "image": "https://www.digitalscanninggroup.com/logo.png",
  "foundingDate": "2018",
  "founder": {
    "@type": "Person",
    "name": "Lee"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "167-169 Great Portland Street",
    "addressLocality": "London",
    "addressRegion": "Greater London",
    "postalCode": "W1W 5PF",
    "addressCountry": "GB"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "51.5207",
    "longitude": "-0.1440"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+44-7577-705477",
    "email": "lee@digitalscanninggroup.com",
    "contactType": "customer service",
    "availableLanguage": ["English"]
  },
  "areaServed": [
    { "@type": "Place", "name": "United Kingdom" },
    { "@type": "Place", "name": "Europe" },
    { "@type": "Place", "name": "Worldwide" }
  ],
  "sameAs": [
    "https://www.linkedin.com/company/digital-scanning-group",
    "https://www.google.com/maps?cid=8643113692861604059"
  ],
  "knowsAbout": [
    "Matterport 3D Scanning",
    "Point Cloud Surveys",
    "Revit BIM Modelling",
    "Drone Surveys",
    "Timelapse Cameras",
    "Digital Twins",
    "3D Laser Scanning",
    "Virtual Tours",
    "CGI Visualization",
    "Reality Capture",
    "As-Built Documentation",
    "Construction Surveying",
    "Healthcare Virtual Tours",
    "Heritage Scanning"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "3D Scanning & Digital Twin Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Matterport 3D Surveys"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Point Cloud Scanning"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Revit BIM Modelling"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Drone Surveys"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Timelapse Cameras"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "CGI Staging & Visualization"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Hologram Technology"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Matterport Virtual Tours London"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "3D Laser Scanning"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Digital Twin Creation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Scan to BIM / Revit Modelling"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "As-Built Documentation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Healthcare & NHS Virtual Tours"
        }
      }
    ]
  },
  "numberOfEmployees": {
    "@type": "QuantitativeValue",
    "minValue": 5,
    "maxValue": 20
  }
};

export const constructionServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "3D Laser Scanning for Construction",
  "name": "Construction 3D Scanning & BIM Modelling",
  "provider": {
    "@type": "Organization",
    "name": "Digital Scanning Group",
    "url": "https://www.digitalscanninggroup.com"
  },
  "areaServed": [
    { "@type": "Place", "name": "United Kingdom" },
    { "@type": "Place", "name": "Europe" }
  ],
  "description": "Matterport 3D surveys, point cloud scanning, Revit BIM modelling, gridlines and datums for construction projects. Pre-works surveys, progress monitoring and as-built documentation.",
  "offers": {
    "@type": "Offer",
    "availability": "https://schema.org/InStock",
    "areaServed": "Europe"
  }
};

export const healthcareServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Healthcare 3D Virtual Tours",
  "name": "NHS & Healthcare 3D Virtual Tours",
  "provider": {
    "@type": "Organization",
    "name": "Digital Scanning Group",
    "url": "https://www.digitalscanninggroup.com"
  },
  "audience": {
    "@type": "Audience",
    "audienceType": "NHS trusts, healthcare providers, patients and families"
  },
  "description": "Matterport 3D virtual tours for NHS hospitals, neonatal units and healthcare facilities. Help patients and families familiarize with clinical environments, reducing anxiety.",
  "areaServed": [
    { "@type": "Place", "name": "United Kingdom" },
    { "@type": "Place", "name": "Europe" }
  ]
};

export const leisureServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "3D Scanning for Leisure & Hospitality",
  "name": "Leisure & Hospitality 3D Virtual Tours",
  "provider": {
    "@type": "Organization",
    "name": "Digital Scanning Group",
    "url": "https://www.digitalscanninggroup.com"
  },
  "description": "Matterport 3D virtual tours and laser scanning for hotels, spas, resorts and hospitality venues. Virtual tours for marketing, renovation planning and heritage preservation.",
  "areaServed": [
    { "@type": "Place", "name": "United Kingdom" },
    { "@type": "Place", "name": "Europe" }
  ]
};

export const cgiServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "CGI Visualization & Virtual Staging",
  "name": "CGI Staging & Photorealistic Visualization",
  "provider": {
    "@type": "Organization",
    "name": "Digital Scanning Group",
    "url": "https://www.digitalscanninggroup.com"
  },
  "description": "Photorealistic CGI visualization and virtual staging for property marketing, heritage buildings, commercial fit-outs and interior design. 3D rendering and animation integrated with scan data.",
  "areaServed": [
    { "@type": "Place", "name": "United Kingdom" },
    { "@type": "Place", "name": "Europe" }
  ]
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Digital Scanning Group",
  "alternateName": "DSG",
  "description": "London's leading Matterport 3D scanning service. Professional point cloud surveys, scan to BIM, drone surveys and virtual tours across London and the UK.",
  "url": "https://www.digitalscanninggroup.com",
  "logo": "https://www.digitalscanninggroup.com/logo.png",
  "image": "https://www.digitalscanninggroup.com/logo.png",
  "telephone": "+44-7577-705477",
  "email": "lee@digitalscanninggroup.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "167-169 Great Portland Street",
    "addressLocality": "London",
    "addressRegion": "Greater London",
    "postalCode": "W1W 5PF",
    "addressCountry": "GB"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "51.5207",
    "longitude": "-0.1440"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "18:00"
    }
  ],
  "priceRange": "$$",
  "areaServed": [
    { "@type": "Place", "name": "London" },
    { "@type": "Place", "name": "United Kingdom" },
    { "@type": "Place", "name": "Europe" }
  ],
  "sameAs": [
    "https://www.linkedin.com/company/digital-scanning-group",
    "https://www.google.com/maps?cid=8643113692861604059"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "27",
    "bestRating": "5",
    "worstRating": "1"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "3D Scanning & Digital Twin Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Matterport 3D Scanning London" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Point Cloud Surveys" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Scan to BIM / Revit Modelling" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Drone Surveys" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Timelapse Cameras" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "CGI Staging & Visualization" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Matterport Virtual Tours" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "3D Laser Scanning" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Digital Twin Creation" }
      },
      {
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": "Hologram Technology" }
      }
    ]
  }
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});
